<form [formGroup]="pageRangeForm">
  <p>
    {{'PDFPAGESELECTDLG.BODY' | translate }}
  </p>
  <div class="wrapperPageRange">
    <div class="right-margin">{{'PDFPAGESELECTDLG.PAGES' | translate }}</div>
    <input formControlName="pageStartControl" type="text" pattern="\d*" min="1" size="1" [value]="firstPage"/>
    <div>&nbsp;-&nbsp;</div>
    <input formControlName="pageEndControl" type="text" pattern="\d*" size="1" min="1" [value]="lastPage" class="right-margin"/>
    <div> ({{'PDFPAGESELECTDLG.DOCMSG' | translate}}&nbsp;{{pageCount}} {{'PDFPAGESELECTDLG.PAGE' | translate }})</div>
  </div>
  @if (ocrCurrentDoc) {
    <span>
      <input formControlName="ocrPageControl" type="checkbox" value="{{ocrCurrentPage}}"/> {{'PDFPAGESELECTDLG.CURRENTPAGE' | translate}}
    </span>
  }
  @if (!isValidated) {
    <div class="error-msg">{{'PDFPAGESELECTDLG.ERROR' | translate}}</div>
  }
  <div class="buttonContainer">
    <input [disabled]="!isValidated" type="submit" value="{{'PDFPAGESELECTDLG.YES' | translate}}" class="cb-btn"
      (click)="ocrSelectedPages(); ok()"/>
      <input type="button" [value]="'PDFPAGESELECTDLG.NO' | translate" class="cb-btn" (click)="no()"/>
    </div>
  </form>

